var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToastSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 188,
    viewBox: "0 0 188 188",
    width: 188,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94,
    fill: "#1ab759",
    r: 94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m82.6413 128.586c-1.9512 0-3.8154-.78-5.1916-2.177l-26.8675-27.3049c-2.8178-2.8688-2.7814-7.4704.0874-10.2956 2.8688-2.8104 7.4778-2.7814 10.2956.0874l21.465 21.8141 44.4078-48.9074c2.716-2.9779 7.318-3.189 10.281-.4949 2.978 2.7014 3.196 7.3029.495 10.2882l-49.5845 54.6081c-1.3469 1.486-3.2401 2.345-5.2424 2.389-.051-.007-.0947-.007-.1458-.007z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccessIcon);
export default __webpack_public_path__ + "static/media/toast-success-icon.4bf9282865fcdb5c19fff5306165a37b.svg";
export { ForwardRef as ReactComponent };